import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CommonButton } from '_components';
import styles from './ChevronDownButton.module.css'


export class AddButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Add'} onClick={this.props.onClick} size={this.props.size} className={cls} disabled={this.props.disabled} >
                <FontAwesomeIcon icon={faPlus} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}